import { useCallback, useState } from 'react';

export const ADMIN_STORAGE_VIEW_ALL_KEY = 'sample_admin_view_all_storage';

function readStoredViewAll(): boolean {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(ADMIN_STORAGE_VIEW_ALL_KEY) === 'true';
}

/** 管理者向け：全保管庫表示トグル（初期値は false＝自分＋共有のみ） */
export function useAdminStorageViewAll(isAdmin: boolean) {
  const [viewAll, setViewAllState] = useState(readStoredViewAll);

  const setViewAll = useCallback((next: boolean) => {
    setViewAllState(next);
    if (typeof window !== 'undefined') {
      localStorage.setItem(ADMIN_STORAGE_VIEW_ALL_KEY, next ? 'true' : 'false');
    }
  }, []);

  return {
    showAdminViewToggle: isAdmin,
    adminViewAll: isAdmin && viewAll,
    setAdminViewAll: setViewAll,
  };
}
